import React, { useState } from 'react'
import injectStyles from 'react-jss'
import { styles } from './styles'
import GenericFlatButton from '../../../../../Components/GenericFlatButton'

const RevokeModal = ({ onClose, onOkay, classes }) => {
  const [isLoading, setIsLoading] = useState(false)
  return (
    <div className={classes.container}>
      <div className={classes.title}>
        Do you really want to revoke this token?
      </div>
      <div className={classes.buttonContainer}>
        <GenericFlatButton
          type={'filled'}
          title={'Yes'}
          onClick={async () => {
            setIsLoading(true)
            await onOkay()
            setIsLoading(false)
          }}
          disabled={isLoading}
          loading={isLoading}
        />
        <GenericFlatButton
          type={'outline'}
          title={'Cancel'}
          onClick={onClose}
        />
      </div>
    </div>
  )
}

export default injectStyles(styles)(RevokeModal)
